import React from "react";
import classNames from "classnames";
import { DatePickerRangeInput } from "frontend/ui-components/date-picker-range/date-picker-range-input";
import { ITaskController } from "../../../controller";
import dropdownStyles from "../edit-task-modal.module.css";
import styles from "./task-date-picker.module.css";

export function TaskDatePicker({
  controller,
  onDateChanged,
}: {
  controller: ITaskController;
  onDateChanged?: () => void;
}) {
  const { element: taskElement } = controller;

  const fromDate = taskElement.fromDate ? new Date(taskElement.fromDate) : undefined;
  const toDate = taskElement.toDate ? new Date(taskElement.toDate) : undefined;

  const handleDateChange = (start?: Date, end?: Date) => {
    controller.setDate(start, end);

    onDateChanged?.();
  };

  return (
    <div className={classNames(dropdownStyles.dropdownPopup, styles.datePickerContainer)}>
      <DatePickerRangeInput
        fromDate={fromDate}
        toDate={toDate}
        onSelected={handleDateChange}
        theme="light"
        showActions="none"
        showInputs={false}
        allowSingleDate={true}
      />
    </div>
  );
}
